/**
 * Another clever approach of writing reducers:
 *
 * export default function(state = initialState, action) {
 *   const actions = {
 *      [ACTION_TYPE]: () => [action.payload.data, ...state]
 *   };
 *
 *   return (_.isFunction(actions[action.type])) ? actions[action.type]() : state
 * }
 */

import * as types from '../constants/ActionTypes';
import { assign } from 'lodash';

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.SET_CURRENT_IMAGE:
      return {
        ...action.resourceInfo
      };
     
    case types.RESET_CURRENT_IMAGE:
      return {};
    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/reducers/currentImage.js
 **/